<template>
  <span>
    <v-card class="elevation-10">
      <subpoenas-header
        :subpoenas="subpoenas"
        :amount="cards"
        :activeStatus="status"
        @activeStatusChanged="changeActiveStatus"
      />
    </v-card>

    <v-progress-linear
      v-if="isLoading"
      indeterminate
      color="teal darken-4"
    />

    <subpoenas-list
      :subpoenas="subpoenas"
      :activeStatus="status"
      :totalPages="total_pages"
      :totalItems="cards.total"
      @changePage="changePage"
    />
  </span>
</template>

<script>
import SubpoenasService from '@/services/applications/SubpoenasService';
import SubpoenasList from '@/components/tabs/list/SubpoenasList';
import SubpoenasHeader from '@/components/tabs/header/SubpoenasHeader';

export default {
  name: 'Subpoenas',
  props: ['isAdmin'],
  components: {
    SubpoenasList,
    SubpoenasHeader,
  },
  data() {
    return {
      status: '',
      page: 1,
      subpoenas: [],
      cards: { total: 0 },
      total_filtered: 0,
      total_pages: 0,
      isLoading: false,
    };
  },
  mounted() {
    this.fetchSubpoenas();
  },
  methods: {
    changeActiveStatus(status) {
      this.status = status;
      this.fetchSubpoenas();
    },
    fetchSubpoenas() {
      this.isLoading = true;
      if (this.isAdmin) {
        this.fetchAdminSubpoenas();
      } else {
        this.fetchUserSubpoenas();
      }
    },
    fetchUserSubpoenas() {
      SubpoenasService
        .fetchSubpoenas({ status: this.status, page: this.page })
        .then(({ data }) => {
          this.subpoenas = data.intimations;
          this.cards = data.cards;
          this.total_filtered = data.total_filtered;
          this.total_pages = data.total_pages;
          this.$emit('amount', this.cards.total);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    fetchAdminSubpoenas() {
      SubpoenasService
        .adminFetchSubpoenas({ status: this.status, page: this.page })
        .then(({ data }) => {
          this.subpoenas = data.intimations;
          this.cards = data.cards;
          this.total_filtered = data.total_filtered;
          this.total_pages = data.total_pages;
          this.$emit('amount', this.cards.total);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    changePage(page) {
      this.page = page;
      this.fetchSubpoenas();
    },
  }
}
</script>